<mulo-centered-block-layout width="full">
  <mulo-side-main-layout [sideColumnSize]="media.is('lt-md') ? 'auto' : '15em'">
    <div [class.padding-sm]="media.is('gt-sm')" slot="layout-side">
      @if (_window?.history?.length > 1) {
        <a (click)="goBack()" class="has-icon back-button" mat-button>
          <mat-icon class="mat-icon-rtl-mirror" svgIcon="chevron-left"></mat-icon>
          {{ 'research.general.back' | translate }}
        </a>
      }
    </div>

    <div [class.padding-sm]="media.is('gt-sm')" slot="layout-main">
      <div class="header-wrap margin-bottom-sm">
        <h1 class="margin-zero">{{ 'esploro.research.cv.page.title' | translate }}</h1>
        <div class="header-actions">
          @if (activeStepIdx > 0) {
            <button
              (click)="openSaveDialog()"
              class="margin-left-md"
              color="primary"
              mat-button
              >
              <span>{{ 'esploro.research.cv.page.button.save' | translate }}</span>
            </button>
          }
          <button
            (click)="openPreview()"
            [disabled]="activeStepIdx < 1"
            class="margin-left-xs has-icon"
            color="primary"
            mat-flat-button
            >
            <mat-icon class="margin-right-xs" muloSvgViewbox svgIcon="eye-outline"></mat-icon>
            <span>{{ 'research.portal.fulldisplay.view.action' | translate }}</span>
          </button>
          <button
            (click)="openDialog()"
            [disabled]="activeStepIdx < 1"
            class="margin-left-xs is-funky-cool has-icon"
            color="primary"
            mat-flat-button
            >
            <mat-icon class="margin-right-xs" muloSvgViewbox svgIcon="download"></mat-icon>
            <span>{{ 'esploro.research.cv.page.button.export' | translate }}</span>
          </button>
        </div>
      </div>
      <div class="margin-bottom-sm">
        <nav [mat-stretch-tabs]="false" [tabPanel]="tabPanel" mat-tab-nav-bar>
          @for (step of steps.controls; track step; let i = $index) {
            <a
              (click)="activeStepIdx = i"
              [active]="activeStepIdx == i"
              [disabled]="!(selectedTemplateId$ | async)"
              mat-tab-link
              >
              <span class="upper">{{ step.value.key | translate }}</span>
            </a>
          }
        </nav>
      </div>
      <mat-tab-nav-panel #tabPanel>
        <esp-cv-template
          (nextStep)="activeStepIdx = 1"
          (templateChange)="selectedTemplateId$.next($event)"
          [form]="steps?.controls?.[0]?.controls?.data"
          [otbTemplates]="otbTemplates"
          [style.display]="activeStepIdx == 0 ? 'block' : 'none'"
          [templateId]="selectedTemplateId$ | async"
          [userTemplates]="userTemplates"
          [loading]="loadingTemplates"
        ></esp-cv-template>
        @if (activeStepIdx === 1) {
          <esp-cv-info
            (nextStep)="activeStepIdx = 2"
            [sections]="infoForm"
          ></esp-cv-info>
        }
        @if (activeStepIdx == 2) {
          <esp-cv-format [form]="steps?.controls?.[2]?.controls?.data"></esp-cv-format>
        }
      </mat-tab-nav-panel>
    </div>
  </mulo-side-main-layout>
</mulo-centered-block-layout>

<ng-template #savingDialogTmpl>
  <h2 cdkFocusInitial mat-dialog-title>{{ 'esploro.research.cv.page.saveNew.dialog.title' | translate }}</h2>
  <form>
    <div mat-dialog-content>
      <p class="margin-bottom-sm">{{ 'esploro.research.cv.page.saveNew.dialog.message' | translate }}</p>
      <mat-form-field class="fill-width padding-bottom-xs">
        <mat-label>{{ 'esploro.research.cv.page.saveNew.dialog.placeholder' | translate }}</mat-label>
        <input [formControl]="newTemplateName" matInput />
        <mat-error>
          <span [innerHTML]="'research.field.required.error.message' | customTranslate"></span>
        </mat-error>
      </mat-form-field>
    </div>
    <div mat-dialog-actions style="justify-content: flex-end">
      <button
        #confirm
        [disabled]="newTemplateName.invalid"
        class="is-large"
        color="primary"
        mat-button
        mat-dialog-close="ok"
        type="submit"
        >
        {{ 'research.portal.entity.item.save' | translate }}
      </button>
      <button #cancel mat-button mat-dialog-close="cancel">
        {{ 'research.aria.dialog.cancel' | translate }}
      </button>
    </div>
  </form>
</ng-template>
<ng-template #savedDialogTmpl>
  <div cdkAriaLive="polite" class="success-msg dialog-content padding-right-md">
    <mulo-animated-checkmark [animate]="true" class="dialog-icon"></mulo-animated-checkmark>
    {{ 'esploro.research.cv.page.saveNew.dialog.success' | translate }}
  </div>
</ng-template>
<ng-template #successDialogTmpl>
  <div cdkAriaLive="polite" class="success-dialog-content">
    <div class="success-msg">
      <mulo-animated-checkmark [animate]="true" class="dialog-icon"></mulo-animated-checkmark>
      <div class="success-msg-text">
        {{ 'esploro.research.cv.page.download.message' | translate }}
      </div>
      <button
        [aria-label]="'research.aria.dialog.close.dialog' | translate"
        class="success-msg-close"
        mat-icon-button
        matDialogClose
        >
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>
    <div class="success-msg-more">
      {{ 'esploro.research.cv.page.download.success.message' | translate }}
    </div>
  </div>
</ng-template>
<ng-template #errorDialogTmpl>
  <div cdkAriaLive="polite" class="error-msg dialog-content">
    {{ 'research.portal.fulldisplay.errorStatus.unknown' | translate }}
  </div>
</ng-template>
<ng-template #previewTemplate>
  <button
    [aria-label]="'research.aria.dialog.close.dialog' | translate"
    class="esp-viewer-dialog-close has-shadow"
    mat-mini-fab
    matDialogClose
    >
    <mat-icon svgIcon="close"></mat-icon>
  </button>
  <esp-arcview-container
    [enableStandalone]="false"
    [items]="previewItems"
    [loading]="loadingForPreview"
  ></esp-arcview-container>
</ng-template>
